const ITEMS = [
  "Rosset Conciergerie & Services",
  "Entretien d'immeubles & PPE",
  "Nettoyages spéciaux",
  "Haute pression",
  "Petits & moyens travaux",
  "Sion, Valais central & Bas-Valais",
  "Devis gratuit",
];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-lagoon/15 bg-nuit py-5" data-testid="editorial-marquee" aria-hidden="true">
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center whitespace-nowrap">
              <span className="px-8 font-display text-sm font-medium uppercase tracking-[0.25em] text-lagoon/90">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-lagoon/40" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
